import { EvaluationResult } from 'models/evaluationResult.model'
import api from '..'

export interface ResSendEvaluation {
  data: Data
}

export interface Data {
  id: string
  type: string
  attributes: EvaluationResult
}

const sendEvaluation = (data: any) => {
  return api.post<ResSendEvaluation>(`/evaluations`, data)
}

export default sendEvaluation
